const hotspotCopy = {
  foam: {
    eyebrow: "Foam / cushioning",
    title: "Bounces Back Every Time",
    body: "Built with premium 30D high-density foam cushioning (1.87 lb/ft³) that delivers consistent support and is made to last.",
    detailSrc: "//monvane.com/cdn/shop/t/38/assets/materials-durability-inline-11.webp?v=63007979361195785601784081508",
    detailLeft: "50%",
    detailTop: "61%",
    detailImage: "url(\"//monvane.com/cdn/shop/t/38/assets/materials-durability-inline-11.webp?v=63007979361195785601784081508\")",
    detailSize: "100% 100%",
    detailPosition: "50% 50%",
    detailDiameter: "clamp(124px, 12vw, 168px)"
  },
  fabric: {
    eyebrow: "Fabric / upholstery",
    title: "Soft Feel, Easy Care",
    body: "Each fabric brings its own distinct character, while all offer a soft touch and a smooth, easy-care finish.",
    detailSrc: "//monvane.com/cdn/shop/t/38/assets/materials-durability-inline-12.webp?v=154352695356908401251784081508",
    detailLeft: "82%",
    detailTop: "58%",
    detailImage: "url(\"//monvane.com/cdn/shop/t/38/assets/materials-durability-inline-12.webp?v=154352695356908401251784081508\")",
    detailSize: "300% auto",
    detailPosition: "48% 48%"
  },
  base: {
    eyebrow: "Base / non-slip support",
    title: "Stays Put, Feels Secure",
    body: "Every Monvane sofa features a non-slip base designed to improve stability and help each module stay securely in place.",
    detailSrc: "//monvane.com/cdn/shop/t/38/assets/materials-durability-inline-13.webp?v=53206776345253564811784081507",
    detailLeft: "20%",
    detailTop: "74%",
    detailImage: "url(\"//monvane.com/cdn/shop/t/38/assets/materials-durability-inline-13.webp?v=53206776345253564811784081507\")",
    detailSize: "auto 100%",
    detailPosition: "50% 50%",
    detailDiameter: "clamp(150px, 15vw, 210px)",
    detailFilter: "brightness(1.42) contrast(1.16) saturate(1.04)"
  }
};

const hotspotStage = document.querySelector(".hotspot-stage");
const hotspotCard = document.querySelector(".hotspot-card");
const hotspotButtons = document.querySelectorAll(".hotspot");
const eyebrow = document.getElementById("hotspot-eyebrow");
const title = document.getElementById("hotspot-title");
const body = document.getElementById("hotspot-body");

const preloadHotspotImages = () => {
  Object.values(hotspotCopy).forEach((copy) => {
    if (!copy.detailSrc) return;

    const image = new Image();
    image.src = copy.detailSrc;
    image.loading = "eager";
    image.decoding = "async";

    if (typeof image.decode === "function") {
      image.decode().catch(() => {});
    }
  });
};

const closeHotspot = () => {
  hotspotStage.classList.remove("has-active");
  hotspotStage.removeAttribute("data-active");
  hotspotCard.setAttribute("aria-hidden", "true");
  hotspotButtons.forEach((item) => {
    item.classList.remove("active");
    item.setAttribute("aria-expanded", "false");
  });
};

const openHotspot = (button) => {
  const key = button.dataset.key;
  const copy = hotspotCopy[key];
  hotspotButtons.forEach((item) => {
    const isActive = item === button;
    item.classList.toggle("active", isActive);
    item.setAttribute("aria-expanded", String(isActive));
  });
  hotspotStage.classList.add("has-active");
  hotspotStage.dataset.active = key;
  hotspotStage.style.setProperty("--detail-image", copy.detailImage);
  hotspotStage.style.setProperty("--detail-left", copy.detailLeft);
  hotspotStage.style.setProperty("--detail-top", copy.detailTop);
  hotspotStage.style.setProperty("--detail-size", copy.detailSize);
  hotspotStage.style.setProperty("--detail-position", copy.detailPosition);
  hotspotStage.style.setProperty("--detail-diameter", copy.detailDiameter || "clamp(124px, 12vw, 168px)");
  hotspotStage.style.setProperty("--detail-filter", copy.detailFilter || "none");
  hotspotCard.setAttribute("aria-hidden", "false");
  eyebrow.textContent = copy.eyebrow;
  title.textContent = copy.title;
  body.textContent = copy.body;
};

hotspotButtons.forEach((button) => {
  button.addEventListener("click", (event) => {
    event.stopPropagation();
    openHotspot(button);
  });
});

document.addEventListener("click", () => {
  if (hotspotStage.classList.contains("has-active")) {
    closeHotspot();
  }
});

document.addEventListener("keydown", (event) => {
  if (event.key === "Escape" && hotspotStage.classList.contains("has-active")) {
    closeHotspot();
  }
});

const setupInteractiveMedia = () => {
  const videos = document.querySelectorAll(".interactive-media video");
  const play = (video) => {
    video.muted = true;
    video.play().catch(() => {});
  };

  if ("IntersectionObserver" in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          play(entry.target);
        } else {
          entry.target.pause();
        }
      });
    }, { threshold: .28 });

    videos.forEach((video) => observer.observe(video));
  } else {
    videos.forEach(play);
  }

  videos.forEach((video) => {
    video.addEventListener("pointerenter", () => play(video));
    video.addEventListener("focus", () => play(video));
  });
};

window.addEventListener("DOMContentLoaded", () => {
  preloadHotspotImages();
  setupInteractiveMedia();
  if (window.lucide) {
    window.lucide.createIcons();
  }
});
